const getBaseURLWithRegion = () => {
  const domainParts =
    window.location.hostname && window.location.hostname.indexOf('.') > -1
      ? window.location.hostname.split('.')
      : [];
  const regionPart = domainParts.length > 1 ? domainParts[1] : process.env.VUE_APP_REGION;
  //`${process.env.VUE_APP_REST_PROTOCOL}//${process.env.VUE_APP_REST_SUBDOMAIN}.${process.env.VUE_APP_REGION}.${process.env.VUE_APP_REST_DOMAIN}`;
  return `${process.env.VUE_APP_REST_PROTOCOL}//${process.env.VUE_APP_REST_SUBDOMAIN}.${regionPart}.${process.env.VUE_APP_REST_DOMAIN}`;
};
const redirectURLWithRegion = (regionId) => {
  const domainParts =
    window.location.hostname && window.location.hostname.indexOf('.') > -1
      ? window.location.hostname.split('.')
      : [];
  const pathname = window.location.pathname || '';
  const regionPart = domainParts.length > 1 ? domainParts[1] : '';
  if (regionPart && regionPart !== regionId) {
    domainParts.splice(1, 1, regionId);
    const redirectDomain = domainParts.join('.');
    const redirectUrl = `${window.location.protocol}//${redirectDomain}${pathname}`;
    window.location.assign(redirectUrl);
  }
};

const getRegionFromDomain = () => {
  const domainParts =
    window.location.hostname && window.location.hostname.indexOf('.') > -1
      ? window.location.hostname.split('.')
      : [];
  const regionId = domainParts.length > 1 ? domainParts[1] : process.env.VUE_APP_REGION;
  return regionId;
};
export { getBaseURLWithRegion, redirectURLWithRegion, getRegionFromDomain };
